import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-checkout-modal',
  templateUrl: './checkout-modal.component.html',
  styleUrls: ['./checkout-modal.component.scss'],
})
export class CheckoutModalComponent implements OnInit {

  @Input()
  alt: string;

  @Input()
  src: string;

  @Input()
  text: string;

  constructor(private modalController: ModalController) { }

  ngOnInit() {
  }

  cancel() {
    this.modalController.dismiss();
  }

}
